<div style="height: 100%;" (window:resize)="onResize($event)">
  <mat-drawer-container class="monitorDrawer" [hasBackdrop]="false">

    <mat-drawer mode="side" [opened]="true" [@slider]="sidebarOpen? null : 'show'" class="slider monitorMaatDrawer">
      <div>
        <button class="matbtn1"  mat-icon-button (click)="toggleSidebar()">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
      @if (sidebarOpen) {
        <div style="margin: 1rem 0.5rem 0.5rem 0.5rem;">
          <h6><b>{{'MarketMonitor.monitor.lblActions' | translate}}</b></h6>
          <div class="row" style="width: 400px;" >
            <div class="col-6">
              <mat-label style="white-space: nowrap;">{{'MarketMonitor.monitor.lblMarketOptions' | translate}}</mat-label>
            </div>
            <div class="col-6">
              @if (service.currentUser.isReadOnly === false) {
                <div style="float: right;">
                  <mat-label style="font-size: small;">{{'MarketMonitor.monitor.lblPauseResume' | translate}}</mat-label>&nbsp;
                  @if (market.isPaused === true) {
                    <button style="border-radius: 5px;" (click)="OnClickPause()" [disabled]="market.canEnablePause === false"
                    >{{'MarketMonitor.monitor.btnResume' | translate}}</button>
                  }
                  @if (market.isPaused === false) {
                    <button style="border-radius: 5px;" (click)="OnClickPause()" [disabled]="market.canEnablePause === false"
                    >{{'MarketMonitor.monitor.btnPause' | translate}}</button>
                  }
                </div>
              }
            </div>
          </div>
          <div class="row" style="width: 400px;">
            <div class="col-6">
              @if (service.currentUser.isReadOnly === false) {
                <div>
                  <mat-label style="font-size: small;">{{'MarketMonitor.monitor.lblExtend' | translate}}</mat-label>&nbsp;
                  <button style="border-radius: 10px;" color="secondary" (click)="OnClickWindowTimeChange(-1)"
                  [disabled]="market.extension <= 0 || market.canEnableExtend === false || service.currentUser.isReadOnly === true">-</button>
                  <input [ngClass]="{'text-danger':market.extension !== 0}" class="monitorInputOpened" [(ngModel)]="market.extension"
                    [ngModelOptions]="{standalone: true}" readonly />
                    <button style="border-radius: 10px;" color="secondary" (click)="OnClickWindowTimeChange(1)"
                    [disabled]="market.canEnableExtend === false || service.currentUser.isReadOnly === true">+</button>
                  </div>
                }
              </div>
              <div class="col-6">
                @if (market.canVisibleReCalc && service.currentUser.isReadOnly === false) {
                  <div style="float: right;" >
                    <mat-label style="font-size: small;">{{'MarketMonitor.monitor.lblRecalc' | translate}}</mat-label>&nbsp;
                    @if (market.canVisibleReCalc) {
                      <button style="border-radius: 5px;" (click)="OnClickReCalc()" [disabled]="market.canEnableReCalc === false"
                      >{{'MarketMonitor.monitor.btnReCalc' | translate}}</button>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="row">
              <div class="col-8">
                <mat-label style="white-space: nowrap;">{{'MarketMonitor.monitor.lblExportData' | translate}}</mat-label>
              </div>
              <div class="col-4">
                <div style="float: right;">
                  <i style="font-size: 1.5em;" class="fa fa-file-excel-o clickable text-success"
                  aria-hidden="true" (click)="OnClickExport()" title="Export to Excel"></i>
                </div>
              </div>
            </div>
            <mat-form-field class="matDrawrtFormField">
              <mat-label>{{'MarketMonitor.monitor.lblComments' | translate}}:</mat-label>
              <textarea style="height: 75px;" matInput [(ngModel)]="newComments"
              [ngModelOptions]="{standalone: true}"></textarea>
              <button [disabled]="service.currentUser.isReadOnly === true || market.canEnableEdit === false" matSuffix mat-stroked-button
              (click)="OnClickCommentSet()">{{'MarketMonitor.monitor.btnSet' | translate}}</button>
            </mat-form-field>
          </div>
        }
        @if (!sidebarOpen) {
          <div style="text-align: center;">
            <div>
              @if (market.isPaused === true) {
                <button style="border-radius: 5px; margin-top: 10px; padding: 0px;" (click)="OnClickPause()" [disabled]="market.canEnablePause === false"
                  ><span style="vertical-align: top;" class="material-icons-outlined">play_arrow</span></button>
                }
                @if (market.isPaused === false) {
                  <button style="border-radius: 5px; margin-top: 10px; padding: 0px;" (click)="OnClickPause()" [disabled]="market.canEnablePause === false"
                    ><span style="vertical-align: top;" class="material-icons-outlined">pause</span></button>
                  }
                </div>
                <div>
                  <input [ngClass]="{'text-danger':market.extension !== 0}" class="monitorInputClosed" [(ngModel)]="market.extension" [ngModelOptions]="{standalone: true}" readonly />
                </div>
              </div>
            }
          </mat-drawer>
          <mat-drawer-content id="monitorMainDrawerContent" [@sliderContent]="{value: (sidebarOpen? null : 'show'), params: {pageWidth: getCurrentWidth()}}"  style="width: 100%;" >
            <app-header style="width: 100%;"></app-header>
            <div class="container-fluid" style="padding: 20px;">
              <h6 style="color: white; margin: -47px 0px 0px 0px; position: absolute;">{{market.description}} ({{market.code}})</h6>
              <div class="row">
                <div class="col-3 m-auto text-center headingItem">
                  <b>{{'MarketMonitor.monitor.lblConWinTime' | translate}}</b> <br />
                  {{market.contributionStart}} - {{market.contributionFinish}}
                </div>
                <div class="col-3 m-auto text-center headingItem">
                  <b>{{'MarketMonitor.monitor.lblTimetoClose' | translate}}</b> <br />
                  {{remainingTimeClose}}
                </div>
                <div class="col-3 m-auto text-center headingItem">
                  <b>{{'MarketMonitor.monitor.lblTimetoPublish' | translate}}</b> <br />
                  {{remainingTimePublish}}
                </div>
                <div class="col-3 m-auto text-center headingItem">
                  <b>{{'MarketMonitor.monitor.lblShow' | translate}}</b> <br/>
                  <div class="col-12 matselect">
                    <!-- <mat-label>{{'MarketMonitor.monitor.lblShow' | translate}}</mat-label> -->
                    <mat-select [(ngModel)]="selectedShow" [ngModelOptions]="{standalone: true}" (selectionChange)="GetMarketDetails(); ResetChange();">
                      <mat-option value="0">{{'MarketMonitor.monitor.lstItemContributions' | translate}}</mat-option>
                      <mat-option value="1">{{'MarketMonitor.monitor.lstItemNonContributions' | translate}}</mat-option>
                      <mat-option value="2">{{'MarketMonitor.monitor.lstItemLoggedIn' | translate}}</mat-option>
                      <mat-option value="3">{{'MarketMonitor.monitor.lstItemLoggedOut' | translate}}</mat-option>
                      <mat-option value="4">{{'MarketMonitor.monitor.lstItemAll' | translate}}</mat-option>
                    </mat-select>
                  </div>
                </div>
              </div>
              <!-- <div class="row">
              <div class="col-6">
                <button mat-stroked-button color="secondary" (click)="OnClickWindowTimeChange(-1)"
                [disabled]="market.extension <= 0 || market.isMarketOpen === false || service.currentUser.isReadOnly === true">-</button>
                <input class="monitorInput" [(ngModel)]="market.extension"
                  [ngModelOptions]="{standalone: true}" readonly />
                  <button mat-stroked-button color="secondary" (click)="OnClickWindowTimeChange(1)"
                  [disabled]="market.isMarketOpen === false || service.currentUser.isReadOnly === true">+</button>
                </div>
                <div class="col-6 text-right">
                  <div *ngIf="service.currentUser.isReadOnly === false">
                    <button (click)="OnClickPause()" [disabled]="market.canEnablePause === false"
                      *ngIf="market.isPaused === true"
                    mat-stroked-button>{{'MarketMonitor.monitor.btnResume' | translate}}</button>
                    <button (click)="OnClickPause()" [disabled]="market.canEnablePause === false"
                      *ngIf="market.isPaused === false"
                    mat-stroked-button>{{'MarketMonitor.monitor.btnPause' | translate}}</button>
                    <button (click)="OnClickReCalc()" [disabled]="market.canEnableReCalc === false"
                      *ngIf="market.canVisibleReCalc"
                    mat-stroked-button>{{'MarketMonitor.monitor.btnReCalc' | translate}}</button>
                  </div>
                </div>
              </div> -->
              <div class="row" style="margin-top: 30px;">
                <div class="text-center col-12 text-success">
                  {{market.comments}}
                </div>
              </div>
              <div class="row">
                <div class="text-center col-12">
                  {{market.status}}
                </div>
              </div>
              <div class="m-4">
                <div class="scrollableTable mat-elevation-z6" style="width: 100%;" #TABLE>
                  <!-- <div style="width: 100%;">
                  <div style="float: right; margin: 10px;">
                    <i style="font-size: 1.5em;" class="fa fa-file-excel-o clickable text-success"
                    aria-hidden="true" (click)="OnClickExport()" title="Export to Excel"></i>
                  </div>
                </div> -->
                <table #table mat-table [dataSource]="dataSource" matSort matSortActive="contributor"
                  matSortDisableClear matSortDirection="asc">

                  @for (column of displayColumnsDynamic; track column) {
                    <ng-container matColumnDef="{{column}}">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef  class="tableFilterFont"
                      [style.width]="50/displayColumnsDynamic.length + '%'"> {{column}} </th>
                      <td mat-cell *matCellDef="let element">
                        @if (OnDataBound(element, column, 'value'); as returnData) {
                          <div>
                            <mat-label class="{{returnData.responseOne}}" matBadge="{{returnData.responseTwo}}" class="stretch-badge" matBadgeSize="small">{{returnData.responseThree}}</mat-label>
                          </div>
                        }
                      </td>
                      <td mat-footer-cell *matFooterCellDef>
                        @if (OnDataBound(null, column, 'outlier'); as returnData) {
                          <div>
                            <mat-label class="{{returnData.responseOne}}" matBadge="{{returnData.responseTwo}}" class="stretch-badge" matBadgeSize="small">{{returnData.responseThree}}</mat-label>
                          </div>
                        }
                      </td>
                    </ng-container>
                  }

                  <ng-container matColumnDef="contributor">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 15%;" class="tableFilterFont">
                    {{'MarketMonitor.monitor.thContributor' | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                      <mat-label class="{{element.hasRefix === true ? 'hasRefix' : ''}} contributorBadge" matBadge="{{element.noOfContributions}}" matBadgeSize="small" [matBadgeHidden]="element.noOfContributions <= 0" >
                        <mat-icon
                          class="{{element.matIconColor}} {{element.status === 4 ? 'clickable' : ''}}"
                        (click)="OnClickStatus(element)"> {{element.matIcon}}</mat-icon>
                      </mat-label>
                      <span style="vertical-align: super; margin-left: 10px;"><u class="clickable" (click)="OnClickContributor(element)">{{element.contributor}}</u></span>
                    </td>
                    <td mat-footer-cell *matFooterCellDef> {{market.tableFooterHeading}} </td>
                  </ng-container>

                  <ng-container matColumnDef="loggedIn">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 10%;" class="tableFilterFont">
                    {{'MarketMonitor.monitor.thLoggedIn' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{(element.relatedUserInfo.length > 1 ? element.relatedUserInfo[1].loggedIn : element.relatedUserInfo[0].loggedIn) === true ? 'Yes' : 'No'}}</td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>

                  <ng-container matColumnDef="name">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 20%;" class="tableFilterFont">
                    {{'MarketMonitor.monitor.thName' | translate}}</th>
                    <td mat-cell *matCellDef="let element" (click)="OnClickName(element.relatedUserInfo.length > 1 ? element.relatedUserInfo[1] : element.relatedUserInfo[0])" class="clickable">
                      <u>{{element.relatedUserInfo.length > 1 ? element.relatedUserInfo[1].firstName : element.relatedUserInfo[0].firstName}} {{element.relatedUserInfo.length > 1 ? element.relatedUserInfo[1].lastName : element.relatedUserInfo[0].lastName}}</u>
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef style="width: 5%; text-align: center;"> </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                      @if (service.currentUser.isReadOnly === false && market.canEnableEdit === true) {
                      <button mat-icon-button color="primary" (click)="OnEditElement(element)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      }
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>

                  <ng-container matColumnDef="loading">
                    <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'tblLoading' |
                      translate}}...
                    </th>
                  </ng-container>

                  <ng-container matColumnDef="noData">
                    <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                      {{'MarketMonitor.tblNoData' |
                    translate}}... </th>
                  </ng-container>

                  <tr style="background-color: #e3e3e3;" mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>

                  <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':(dataSource!=null && isChangedView === false)}">
                  </tr>
                  <tr mat-footer-row *matFooterRowDef="['noData']"
                  [ngClass]="{'hide':((dataSource!=null || isWaitingResults === true) && recordsLength != 0) || isWaitingInitial === true}"></tr>
                  <tr style="background-color: #e3e3e3;" mat-footer-row *matFooterRowDef="displayColumns; sticky: true"></tr>

                </table>
              </div>
            </div>
          </div>
        </mat-drawer-content>
      </mat-drawer-container>
    </div>
